import { Dispatch } from "redux";
import {
  getAvailableProjectMetaFields,
  getAvailableWorkspaceGlobalTaskMetaFields,
} from "src/redux";
import { ExtensionTypeEnum } from "src/types";

export const extensionDetailsInitialState = {
  uuid: "",
  wsProjectUuid: "",
  wsWorkspaceUuid: null,
  type: "",
  settings: { token: "", wsTaskMetaFieldUuid: "" },
  enabled: false,
  recruitmentFormUuid: "",
  recruitmentFormMetaFields: [],
  recruitmentFormMembersWithNotification: [],
  recruitmentFormMetaFieldsAvailable: [],
  recruitmentFormCaption: "",
  recruitmentFormDescription: "",
  recruitmentFormSuccessMessage: "",
  recruitmentIframeHtml: "",
  recruitmentFormUrl: "",
  wsAccessLinkCover: null,
  wsAccessLinkLogo: null,
};

export const initialUserData = {
  recruitmentFormMetaFields: {
    metaFields: [],
    membersWithNotification: [],
    caption: "",
    description: "",
    successMessage: "",
  },
  wsAccessLinkCover: null,
  wsAccessLinkLogo: null,
  recruitmentFormUuid: null,
  wsExtensionType: null,
};

export const getAvailableMetaFields = ({
  dispatch,
  contextUuid,
  extensionType,
}: {
  dispatch: Dispatch<any>;
  contextUuid: string;
  extensionType: ExtensionTypeEnum;
}) => {
  if (extensionType === ExtensionTypeEnum.RecruitmentForm) {
    dispatch(getAvailableProjectMetaFields(contextUuid));
  }

  if (extensionType === ExtensionTypeEnum.CreatorDatabaseSubmissionForm) {
    dispatch(getAvailableWorkspaceGlobalTaskMetaFields(contextUuid));
  }
};

export const getExtensionAssetObject = (
  imageFile: File,
  wsRecruitmentFormUuid: string,
  name: string,
) => {
  return {
    parentUuid: wsRecruitmentFormUuid,
    name: imageFile?.name,
    mimeType: imageFile?.type,
    realName: name,
    size: imageFile?.size,
  };
};
